import { TaskCardBase, TaskCardBaseProps } from "~components";

type EmptyTaskCardProps = Pick<TaskCardBaseProps, "title" | "description">;

export function EmptyTaskCard(props: EmptyTaskCardProps) {
  const { title, description } = props;
  return <TaskCardBase title={title} description={description} />;
}
